// extracted by mini-css-extract-plugin
export default {"filter":"SchoolsList-module__filter--GUb5G","schoolType":"SchoolsList-module__schoolType--GMPfo","accreditations":"SchoolsList-module__accreditations--mMvHT"};